"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestAssistantConversations = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
// One page carries whole conversations, messages included. That is affordable because they are
// small — measured on DEV at ~430 characters each, so a page of 20 is under 10 KB — and it means
// reading one costs no second request.
const ASSISTANT_CONVERSATIONS_QUERY = (0, graphql_tag_1.default) `
  query AssistantConversationsQuery($workspace: ID!, $limit: Int, $skip: Int) {
    assistantConversations(workspace: $workspace, limit: $limit, skip: $skip) {
      id
      sessionId
      created
      messages {
        role
        content
        created
      }
    }
  }
`;
/**
 * The calling user's own archived conversations on one workspace, newest first.
 *
 * Scoping is entirely the server's: `findConversations` filters on the authenticated user AND
 * the workspace argument, so there is no way for this to return somebody else's chats or
 * another workspace's. The page size is capped server-side at 100.
 */
const requestAssistantConversations = async (variables, errorsCallback) => {
    const { data, errors } = await (0, apollo_1.query)(ASSISTANT_CONVERSATIONS_QUERY, { variables });
    (0, error_handler_1.processErrors)(errors);
    errorsCallback?.(errors);
    return data?.assistantConversations ?? undefined;
};
exports.requestAssistantConversations = requestAssistantConversations;
exports.default = exports.requestAssistantConversations;
